export default __webpack_public_path__ + "static/media/Lu.8f03a2c0.png";